<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleChange(1)">
        <i class="iconfont iconProperty1tianjia"></i> New
      </el-button>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Number" prop="id" min-width="140"></el-table-column>
        <el-table-column
          label="label"
          prop="labelName"
          show-overflow-tooltip
          min-width="280"
          style="background:red"
        >
          <template v-slot="{row}">
            <div
              class="table-label"
              :style="{color:row.fontColor,background:row.backgroundColor,padding: '10px',borderRadius: '4px'}"
            >{{ row.labelName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Set Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Last Modify Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.lastUpdateTime">{{ formatUtc(row.lastUpdateTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Last Modifier" prop="lastUpdateModifier" min-width="150"></el-table-column>
        <el-table-column label="Remark" prop="remark" :show-overflow-tooltip="true" min-width="234"></el-table-column>

        <el-table-column label="Operation" min-width="214" fixed="right">
          <template v-slot="{row}">
            <div>
              <el-button class="table-inner-btn" @click="handleChange(2,row)">Modify</el-button>
              <el-button class="table-inner-btn" @click="handleChange(3,row)">Delete</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.pageSize"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="form" label-width="56px">
          <el-form-item label="Label">
            <el-input v-model="form.labelName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="form.remark" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="bgColor">
            <el-color-picker v-model="form.backgroundColor"></el-color-picker>
          </el-form-item>
          <el-form-item label="fontColor">
            <el-color-picker v-model="form.fontColor"></el-color-picker>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewModify()" v-if="num == 2">Confirm</el-button>
          <el-button class="search-btn" @click="handleViewAdd()" v-if="num == 1">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getLableList,
  getLableDelete,
  getLableUpdate,
  getLableAdd
} from "@/api/lable";
export default {
  name: "LableList",
  data() {
    return {
      form: {
        labelName: "",
        remark: "",
        id: "",
        backgroundColor: "",
        fontColor: ""
      },
      id: "",
      num: "",
      list: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        pageSize: 50
      },
      labelId: "",
      tableHeight: window.innerHeight,
      title: "Delete the Label?"
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getLableList(this.queryData);
        const data = res.data || {};
        this.list = data.record || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 查看详情
    handleViewDetail(data) {
      this.$router.push({
        path: "/risk/detail",
        query: { riskLevelId: data.riskLevelId }
      });
    },
    // 添加
    async handleViewAdd(data) {
      if (this.form.labelName) {
        const res = await getLableAdd(this.form);
        if (res.success) {
          this.$message({ message: "add success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The lablename can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "New Label";
        this.form = {};
      } else if (num == 2) {
        // 修改
        this.title = "Modify Label";
        this.form.labelName = data.labelName;
        this.form.remark = data.remark;
        this.form.id = data.id;
        this.form.fontColor = data.fontColor;
        this.form.backgroundColor = data.backgroundColor;
      } else {
        // 删除
        this.title = "Delete Label?";
        this.labelId = data.id;
      }
      this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
    },
    // 修改
    async handleViewModify(data) {
      if (this.form.labelName != "") {
        const res = await getLableUpdate(this.form);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The lablename can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    // 删除
    async Delete() {
      try {
        const res = await getLableDelete({ labelId: this.labelId });
        if (res.code == 0) {
          this.$message({ message: "delete success", type: "success" });
          this.getList();
          this.Close();
        }
      } catch (error) {
        this.Close();
      }
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "323px");
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
.table-label {
  color: #666;
  font-weight: bold;
}
/deep/.el-form-item__label {
  width: 80px !important;
}
/deep/.el-form-item__content {
  margin-left: 80px !important;
}
</style>
